import { render, staticRenderFns } from "./LanguageMenuDrawer.vue?vue&type=template&id=5944e65c&scoped=true&"
import script from "./LanguageMenuDrawer.vue?vue&type=script&lang=js&"
export * from "./LanguageMenuDrawer.vue?vue&type=script&lang=js&"
import style0 from "./LanguageMenuDrawer.vue?vue&type=style&index=0&id=5944e65c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5944e65c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListGroup,VListItem,VListItemTitle})
